import { Box, styled } from '@mui/material';
import { ThemedSiderV2 } from '@refinedev/mui';
import { Dashboard } from './Dashboard.tsx';
import { Title } from './Title.tsx';

const SiderWrapper = styled('div')(`
.MuiList-root {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.MuiList-root > * {
  flex: 0 auto;
}
`);

export const Sider = () => {
  return (
    <SiderWrapper>
      <ThemedSiderV2
        Title={Title}
        render={({ items, logout, collapsed }) => {
          return (
            <>
              {items}
              {logout}
              <Box sx={{ mt: 'auto' }}>{!collapsed ? <Dashboard /> : null}</Box>
            </>
          );
        }}
      />
    </SiderWrapper>
  );
};
